export type OutboundBylineSsrStatus = 'present' | 'empty' | 'unavailable';

export type OutboundBylineSsrState = Readonly<{
	contentId: string;
	status: OutboundBylineSsrStatus;
}>;

type OutboundBylineSsrWindow = Window & {
	__SSR_OUTBOUND_BYLINE_STATE__?: OutboundBylineSsrState;
};

const getSsrWindow = (): OutboundBylineSsrWindow => window as OutboundBylineSsrWindow;

export const resetOutboundBylineSsrState = (): void => {
	delete getSsrWindow().__SSR_OUTBOUND_BYLINE_STATE__;
};

export const publishOutboundBylineSsrState = (
	state: OutboundBylineSsrState,
): OutboundBylineSsrState => {
	const ssrWindow = getSsrWindow();

	if (ssrWindow.__SSR_OUTBOUND_BYLINE_STATE__ === undefined) {
		ssrWindow.__SSR_OUTBOUND_BYLINE_STATE__ = state;
	}

	return ssrWindow.__SSR_OUTBOUND_BYLINE_STATE__;
};

export const getOutboundBylineSsrState = (
	contentId: string | undefined,
): OutboundBylineSsrState | undefined => {
	if (contentId === undefined) {
		return undefined;
	}

	const state = getSsrWindow().__SSR_OUTBOUND_BYLINE_STATE__;
	return state?.contentId === contentId ? state : undefined;
};
